/**
 * Utility class for retrieving and handling cookie data.
 */
export default class CookieReader {
	/**
	 * Read the Google Analytics clientId from the document cookie.
	 *
	 * @returns The GA clientId, extracted and trimmed from cookie.
	 * @throws If there is no clientId in the cookie, or the cookie is incorrectly formatted.
	 */
	public getGaId(): string {
		const cookieSeparated = document.cookie.split('; ').filter(value => value.startsWith('_ga='));
		if (cookieSeparated.length == 0) {
			throw new Error('Unable to retrieve Google Analytics cookie.');
		}
		/* Some markets are setting two cookies with the same name
		 * we want to filter out the one that has the following format
		 * _ga=GA1.2.XXXXXXXXXX.XXXXXXXXXX
		 */
		const gaCookie = cookieSeparated.filter(c => c.split('.').length == 4);
		if (!gaCookie.length) {
			throw new Error('GA cookie is incorrectly constructed.');
		}
		const cookieFields = gaCookie[0].split('.');
		return cookieFields[2] + '.' + cookieFields[3];
	}
}
